import React, {useEffect, useState} from "react";
import {useSelector} from "react-redux";
import NoData from "../../../components/NoDataFound/NoData";
import {getCertificateListRequest, getLifetimeCertificateListRequest} from "../../../utils/apis/account";
import "./style.scss";
import LoaderOverlay from "../../../reusableComponents/Loader";
import {Skeleton} from "antd";
import Tabination from "../../../reusableComponents/Tabination";
import shareIcon from "../../../assets/icons/shareIcon.svg";
import ShareModal from "./ShareModal";

const AllCertificates = () => {
  const [activeTab, setActiveTab] = useState(0);
  const [shareModalOpen, setShareModalOpen] = useState(false);
  const [selectedCertificate, setSelectedCertificate] = useState(null);
  const idToken = useSelector((state) => state.auth.idToken);
  const [lifetimeCertificateList, setLifetimeCertificateList] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isTabSwitching, setIsTabSwitching] = useState(false);
  const selectedBrand = useSelector((state) => state.brand.selectedBrand);

  const [challengeCertificates, setChallengeCertificates] = useState([]);
  const [fundedCertificates, setFundedCertificates] = useState([]);
  const [payoutCertificates, setPayoutCertificates] = useState([]);

  const sortByDate = (certificates) => {
    return [...certificates].sort((a, b) => new Date(b.created_at) - new Date(a.created_at));
  };

  const categorizeCertificates = (certificates) => {
    const challenges = [];
    const funded = [];
    const payouts = [];

    certificates.forEach((cert) => {
      if (cert.type === "Profit Split") {
        payouts.push(cert);
      } else if (cert.type === "Funded") {
        funded.push(cert);
      } else if (cert.type === "1 Step Pass" || cert.type === "2 Step Pass") {
        challenges.push(cert);
      }
    });

    setChallengeCertificates(sortByDate(challenges));
    setFundedCertificates(sortByDate(funded));
    setPayoutCertificates(sortByDate(payouts));
  };

  const fetchCertificates = async () => {
    setIsLoading(true);
    try {
      const response = await getCertificateListRequest(idToken, selectedBrand);
      categorizeCertificates(response);
    } catch (error) {
      console.error(error);
    }
    try {
      const lifetimeResponse = await getLifetimeCertificateListRequest(idToken, selectedBrand);
      setLifetimeCertificateList(lifetimeResponse?.file_url ? [lifetimeResponse] : []);
    } catch (error) {
      console.error(error);
    }
    setIsLoading(false);
  };
  useEffect(() => {
    fetchCertificates();
  }, [idToken]);

  function splitTitle(title) {
    const parts = title.split(" - ");
    return {
      id: parts[0]?.trim() || "",
      name: parts[1]?.trim() || "",
      type: parts[2]?.trim() || "",
    };
  }
  useEffect(() => {
    if (isLoading) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }
  }, [isLoading]);

  const [loadedImages, setLoadedImages] = useState({});

  const handleImageLoad = (idx, category) => {
    setLoadedImages((prev) => ({...prev, [`${category}-${idx}`]: true}));
  };

  const handleShareClick = (certificateUrl, certificateTitle, certificateId) => {
    setSelectedCertificate({url: certificateUrl, title: certificateTitle, id: certificateId});
    setShareModalOpen(true);
  };

  const handleTabChange = (newTab) => {
    setIsTabSwitching(true);
    setActiveTab(newTab);
    setTimeout(() => {
      setIsTabSwitching(false);
    }, 300);
  };

  const renderCertificateCard = (item, idx, category) => {
    const imageKey = `${category}-${idx}`;
    const certificateUrl = category === "lifetime" ? item.file_url : item.file;
    const certificateTitle = category === "lifetime" ? "Lifetime Payout" : splitTitle(item.title).type || "Certificate";
    // Get certificate ID - works for both regular and lifetime certificates
    const certificateId = item.id || null;
    // Only show share button for payout and funded certificates
    const isShareable = category === "payout" || category === "funded";

    return (
      <div
        className="certificate-cards"
        key={idx}
      >
        <div className="inner-card">
          <div className="certificate-img">
            {!loadedImages[imageKey] && (
              <div className="skeleton-wrapper">
                <Skeleton.Image active={true} />
              </div>
            )}
            <img
              src={certificateUrl}
              alt="certificate card"
              className="card-img"
              style={{display: loadedImages[imageKey] ? "block" : "none"}}
              onLoad={() => handleImageLoad(idx, category)}
              onError={() => handleImageLoad(idx, category)}
            />
          </div>
          <div className="cert-card-info">
            {category === "lifetime" ? (
              <>
                <div className="cert-card-wrapper">
                  <h2 className="card-title">Payout count</h2>
                  <h2 className="card-title">Total amount</h2>
                </div>
                <div className="cert-card-wrapper">
                  <h2 className="card-title">{item.payout_count}</h2>
                  <h2 className="card-title">${item.total_amount ? parseFloat(item.total_amount).toFixed(2) : "0.00"}</h2>
                </div>
              </>
            ) : (
              <>
                <div className="cert-card-wrapper">
                  <h2 className="card-title">{splitTitle(item.title).name}</h2>
                  <h2 className="card-title">{splitTitle(item.title).type}</h2>
                </div>
                <div className="cert-card-wrapper">
                  <h2 className="card-title">{splitTitle(item.title).id}</h2>
                  <h2 className="date">{item.created_at}</h2>
                </div>
              </>
            )}
          </div>
          <div className="card-actions">
            <a
              href={certificateUrl}
              target="_blank"
              rel="noreferrer"
              style={{width: isShareable ? "auto" : "100%"}}
            >
              <button
                className="download-btn"
                style={{width: "100%"}}
              >
                Download
              </button>
            </a>
            {isShareable && (
              <button
                className="share-btn"
                onClick={(e) => {
                  e.stopPropagation();
                  handleShareClick(certificateUrl, certificateTitle, certificateId);
                }}
              >
                <img
                  src={shareIcon}
                  alt="share"
                />
              </button>
            )}
          </div>
        </div>
      </div>
    );
  };

  return (
    <>
      {isLoading && <LoaderOverlay />}
      <ShareModal
        isOpen={shareModalOpen}
        onClose={() => setShareModalOpen(false)}
        certificateUrl={selectedCertificate?.url || ""}
        certificateTitle={selectedCertificate?.title || ""}
        certificateId={selectedCertificate?.id || null}
      />
      <Tabination
        variant={8}
        activeTab={activeTab}
        setActiveTab={setActiveTab}
        tabItems={[
          {
            name: "Check out my payout certificate",
            content: (
              <>
                {payoutCertificates.length <= 0 && (
                  <div className="certificate-no-data">
                    <NoData msg={"No certificates found"} />
                  </div>
                )}
                <div className="main_certificates">{payoutCertificates.map((item, idx) => renderCertificateCard(item, idx, "payout"))}</div>
              </>
            ),
          },
          {
            name: "Challenge Certificates",
            content: (
              <>
                {challengeCertificates.length <= 0 && (
                  <div className="certificate-no-data">
                    <NoData msg={"No certificates found"} />
                  </div>
                )}
                <div className="main_certificates">{challengeCertificates.map((item, idx) => renderCertificateCard(item, idx, "challenge"))}</div>
              </>
            ),
          },
          {
            name: "Funded Certificates",
            content: (
              <>
                {fundedCertificates.length <= 0 && (
                  <div className="certificate-no-data">
                    <NoData msg={"No certificates found"} />
                  </div>
                )}
                <div className="main_certificates">{fundedCertificates.map((item, idx) => renderCertificateCard(item, idx, "funded"))}</div>
              </>
            ),
          },
          {
            name: "Lifetime Payout Certificates",
            content: (
              <>
                {(!Array.isArray(lifetimeCertificateList) || lifetimeCertificateList.length <= 0) && (
                  <div className="certificate-no-data">
                    <NoData msg={"No certificates found"} />
                  </div>
                )}
                <div className="main_certificates">{Array.isArray(lifetimeCertificateList) && lifetimeCertificateList.map((item, idx) => renderCertificateCard(item, idx, "lifetime"))}</div>
              </>
            ),
          },
        ]}
      />
    </>
  );
};

export default AllCertificates;
